export default function (http) {
    return {
        queryByPage(data) {
            return http.json({
                url: `/prize/query`,
                data
            });
        },
        list(data) {
            return http.json({
                url: `/prize/list`,
                data
            });
        },
        savePrizeInfo(data) {
            return http.json({
                url: '/prize/save',
                data
            })
        },

        getPrizeInfo(data) {
            return http.json({
                url: `/prize/get?id=${data.id}`
            })
        },

        removePrize(data) {
            return http.json({
                url: `/prize/delete?id=${data[0].id}`,
                data
            })
        },


        normalOrDisable(data) {
            return http.json({
                url: `/prize/normalOrDisable?id=${data.id}&state=${data.state}`,
                data
            })
        },

        getSysDictLotteryTime(data) {
            return http.json({
                url: `/common/getLotteryTimeByCode`,
                data
            })
        },

        updateLotteryTime(data) {
            return http.json({
                url: `/common/updateLotteryTime`,
                data
            })
        },

    };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/prize.js